import { render, staticRenderFns } from "./TopicOptions.vue?vue&type=template&id=7fa25681&scoped=true&"
import script from "./TopicOptions.vue?vue&type=script&lang=js&"
export * from "./TopicOptions.vue?vue&type=script&lang=js&"
import style0 from "./TopicOptions.vue?vue&type=style&index=0&id=7fa25681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa25681",
  null
  
)

export default component.exports